import { Badge } from "@/components/ui/badge";
import { STATUT_LABELS } from "../lib/constants";

const COLORS = {
  ACTIF: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  EN_CIRCULATION: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  VALIDE: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  SUCCES: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  TERMINE: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  SUSPENDU: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  IMMOBILISE: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  EN_COURS: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  ANALYSE: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  MAPPING: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  EXPIRE: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  REFORME: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  ANNULE: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  ECHEC: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  BLOQUE: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  INACTIF: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
};

export default function StatusBadge({ value, testid }) {
  if (!value) return <span className="text-muted-foreground">-</span>;
  return (
    <Badge className={`font-medium ${COLORS[value] || COLORS.INACTIF}`} data-testid={testid}>
      {STATUT_LABELS[value] || value}
    </Badge>
  );
}
